export default __webpack_public_path__ + "static/earthsmart-48e1abb3a5b5f117c50463a62a0ba1eb.png";